var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"center-frame",attrs:{"id":_vm.id,"name":_vm.id,"src":_vm.srcWithRoot,"frameborder":"0","title":"galaxy frame","width":"100%","height":"100%"},on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }